export default [
  {
    path: '/categories',
    name: 'categories',
    component: () => import('./CategoriesManage.vue'),
    meta: {
      requiresAuth: true,
      is_admin: true,
      name: 'categories',
    },
  },
]
